import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger
} from '@cmp-src/primitives/Select';
import { cn } from '@gettactic/helpers';
import { UserAvatar } from '@v2/components/display/UserAvatar/UserAvatar';
import { classes } from './utils';

interface RequestSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
  triggerContent: React.ReactNode;
  options: Array<{
    id: string;
    name: string;
    email?: string;
    profile_photo_url?: string;
  }>;
  placeholder?: string;
  className?: string;
}

export const RequestSelect = ({
  value,
  onValueChange,
  disabled = false,
  triggerContent,
  options,
  placeholder = 'Select an option',
  className
}: RequestSelectProps) => {
  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger className={cn(classes.selectTrigger, className)}>
        {triggerContent}
      </SelectTrigger>
      <SelectContent className="z-dropdown p-0">
        {options.map((option) => (
          <SelectItem
            key={option.id}
            value={option.id}
            className="w-full focus:ring-0"
            checkClassName="absolute right-2"
          >
            <div className="flex items-center space-x-2">
              {Object.hasOwn(option, 'profile_photo_url') ? (
                <UserAvatar
                  user={{
                    name:  option.id === 'no-owner' ? '?' : option.name || '?',
                    email: option.email || '',
                    profile_photo_url: option.profile_photo_url || ""
                  }}
                  size="sm"
                  className="flex-shrink-0"
                />
              ) : option.id === 'no-owner' ? (
                <div className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-gray-500">
                  <span className="font-medium text-white text-xs">NA</span>
                </div>
              ) : null}
              <span className="truncate">{option.name}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
